import type { Storage } from '../platform/storage'
import { KEY } from './keys'

/**
 * Начало окна бодрствования — единственное, что нужно сохранять о таймере.
 * Ключ `window_start` читают также виджет, плитка на часах и синхронизация, поэтому
 * имя и формат (миллисекунды, `-1` = окно не идёт) менять нельзя.
 */
export async function loadWindowStart(storage: Storage): Promise<number | null> {
  const raw = await storage.get(KEY.windowStart)
  if (raw === null) return null
  const value = Number(raw)
  return Number.isFinite(value) && value > 0 ? value : null
}

export async function saveWindowStart(storage: Storage, windowStart: number | null, now = Date.now()): Promise<void> {
  await storage.set(KEY.windowStart, String(windowStart ?? -1))
  await storage.set(KEY.windowUpdatedAt, String(now))
  if (windowStart !== null) await storage.set(KEY.lastWake, String(windowStart))
}

export async function windowUpdatedAt(storage: Storage): Promise<number> {
  return Number((await storage.get(KEY.windowUpdatedAt)) ?? 0)
}

/** Когда малыш проснулся в последний раз; показывается на стартовом экране часов. */
export async function lastWake(storage: Storage): Promise<number | null> {
  const raw = await storage.get(KEY.lastWake)
  const value = Number(raw ?? -1)
  return Number.isFinite(value) && value > 0 ? value : null
}
